import { useTranslation } from 'react-i18next';
import { Box, StackView, Typography } from '@telus-uds/components-web';

import { useTheme } from '../../BrandThemeProvider';

import './Header.css';

const Header = () => {
  const { t } = useTranslation();
  const { currentBrand, testMode } = useTheme();

  return (
    <Box variant={{ background: 'lighter' }}>
      {testMode && (
        <Box vertical={1} horizontal={2} flex={1} variant={{ background: 'featurePrimary' }}>
          <StackView tokens={{ flexGrow: 1, alignItems: 'center' }}>
            <Typography variant={{ size: 'h3', inverse: true }} tag="h1">
              {t('testModeBanner')}
            </Typography>
          </StackView>
        </Box>
      )}
      <StackView tokens={{ flexGrow: 1, alignItems: 'center' }}>
        <div className="headerContentContainer">
          <Box vertical={3} horizontal={2} flex={1}>
            <StackView
              direction="row"
              tokens={{
                alignItems: 'left',
                justifyContent: 'flex-start',
                flexGrow: 1,
              }}
            >
              {<img src={`/logos/${currentBrand}.svg`} alt="Brand Logo" className="brand-logo-small" />}
            </StackView>
          </Box>
        </div>
      </StackView>
    </Box>
  );
};

export default Header;
